<template>
    <div class="forsynlistContainer">
        <div slot="table-busy" class="text-center small text-dark my-5 pt-5" v-if="isBusy === true">
            <b-spinner class="align-middle mx-2"></b-spinner>
            <strong>Loading...</strong>
        </div>

        <b-table :items="items"
                 sort-compare-locale="sv"
                 aria-busy="false"
                 v-if="isBusy === false"
                 :sort-by.sync="sortBy"
                 :sort-desc.sync="isDescending"
                 hover small :fields="fields" :tbody-tr-class="rowClass">

            <div slot="Details" slot-scope="data" class="tableHeader btnContainer">
                <!--      <router-link :to="{ name: 'forsyn', params: { id: this.id } }">-->
                <b-button class="btn-visa-forsyn greenSea" :href="`#/forsyn/${data.item.id}`">
                    Info
                </b-button>
            </div>

            <!--<b-button class="btn-visa-forsyn belizeBlue" :href="`#/forsynPDF/${data.item.id}`">
                      PDF
                  </b-button>-->

            <div slot="name" slot-scope="data" class="tableHeader">
                <p>{{ data.item.name}}</p>
            </div>

            <div slot="phone" slot-scope="data" class="tableHeader" >
                <b-button class="btn-visa-phone"
                          :href="`tel:${data.item.phone}`">
                    <p>{{ data.item.phone }}</p>
                </b-button>
            </div>

            <div slot="adress" slot-scope="data" class="tableHeader">
                <p>{{ data.item.adress }}</p>
            </div>

            <div slot="dateForsyn" slot-scope="data" class="tableHeader">
                <p>{{ data.item.dateForsyn }}</p>
            </div>

            <div slot="dateDigging" slot-scope="data" class="tableHeader">
                <p>{{ data.item.dateDigging }}</p>
            </div>

            <div slot="Status" slot-scope="data" >
                <div v-for="item in data.value">
                    <div v-if="item === 'fk'">
                        <badge class="badge"><p>Förprojektering</p></badge>
                    </div>

                    <div v-else-if="item === 'ttt'">
                        <badge class="badge"><p>Tillträde till tomt</p></badge>
                    </div>

                    <div v-else-if="item === 'dthv'">
                        <badge class="badge"><p>Duktad till husvägg</p></badge>
                    </div>

                    <div v-else-if="item === 'fthv'">
                        <badge class="badge">Fiber till husvägg</badge>
                    </div>
                </div>
            </div>

            <div slot="customer_color" slot-scope="data">
                <customer-color-badge :colorname=data.value></customer-color-badge>
            </div>

            <div slot="FOS" slot-scope="data">
                {{ data.value }}
            </div>

            <div slot="Fosfärg" slot-scope="data">
                {{ data.value }}
            </div>

        </b-table>
        <back-to-top text="Back to top" visibleoffset="500" class="btn-to-top">Scroll to top</back-to-top>
    </div>
</template>

<script>
    import { db } from '../main';
    import { Badge } from '../components/Badge';
    import BackToTop from 'vue-backtotop';

    export default {
        name: "forsyn",
        components: {
            Badge,
            BackToTop
        },
        data() {
            return {
                sortBy: 'adress',
                isDescending: false,
                id:this.$route.params.id,
                isBusy: true,
                items: [],
                fields: [
                    {
                        key: "Details",
                        sortable: false,
                        label: "",
                        class: ""
                    },
                    {
                        key: "name",
                        sortable: true,
                        label: "Namn"
                    },
                    {
                        key: "phone",
                        sortable: false,
                        label: "Telefon"
                    },
                    {
                        key: "adress",
                        sortable: true,
                        label: "Adress"
                    },
                    {
                        key: "customer_color",
                        sortable: false,
                        label: "Färg"
                    },
                    {
                        key: "dateForsyn",
                        sortable: true,
                        label: "Försyn"
                    },
                    {
                        key: "dateDigging",
                        sortable: true,
                        label: "Gräv"
                    },
                    {
                        key: "Status",
                        sortable: true,
                        label: "Status"
                    }],
            }
        },
        firestore () {
            return {
                customers: db.collection('customers').orderBy('adress')
            }
        },

        beforeMount(){
            this.getForsynList();
        },

        mounted() {},
        created() {},

        computed: { },            /* Hämtar ifrån store getters  */
        methods: {               /* Methods - mutation = commit */
            async getForsynList () {
                await db.collection('customers').get().then(resp => {
                    let forsynListCollection = [];
                    resp.forEach(doc => {
                        const forsynListData = doc.data();
                        forsynListCollection.push({
                            'id' : doc.id,
                            'name' : forsynListData.name,
                            'phone' : forsynListData.phone,
                            'adress' : forsynListData.adress,
                            'status' : (Array.isArray(forsynListData.dthv) === true),
                            _showDetails: false,    /* Checkbox*/
                            'customer_color': forsynListData.color,
                            'fakturerad': forsynListData.invoiced,
                            'fastBet': forsynListData.fastBet,
                            'dateForsyn': forsynListData.dateForsyn,
                            'timeForsyn': forsynListData.timeForsyn,
                            'dateDigging': forsynListData.dateDigging,
                            'timeDigging': forsynListData.timeDigging,
                            'lat': forsynListData.lat,
                            'lon': forsynListData.lon,
                            'Status':  [forsynListData.fk,forsynListData.fthv,forsynListData.dthv,forsynListData.ttt],
                        })
                    });
                    this.items = forsynListCollection;
                    this.isBusy = false;
                } );
            },
            rowClass(item) {
                if (!item)
                    return;
                if (item.status === true)
                    return 'table-success';
            },
        },
    }
</script>

<style scoped lang="scss">
    .forsynlistContainer {
        min-width: 95%;
    }
    .btn-visa-forsyn {
        font-size: 9pt;
        border-radius: 2px;
        background-color: white;
        line-height: 2;
        min-width: 80px;
        font-weight: 500;
        letter-spacing: 0.2pt;
        padding: 10px 15px;
        font-family: -apple-system,
        BlinkMacSystemFont, "Segoe UI", Roboto,
        "Helvetica Neue", Arial, "Noto Sans", sans-serif,
        "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol",
        "Noto Color Emoji";
        box-shadow: none !important;
        display: flex;
        justify-content: center;
    }
    .btn-visa-phone {
        display: flex;
        justify-content: flex-start;
        font-size: 9pt;
        border-radius: 2px;
        background-color: white;
        color: #333;
        max-width: 110px;
        padding: 0 15px;
        font-weight: 500;
        box-shadow: none !important;
        border: 1px solid transparent !important;
    }
    .btn-visa-phone:active, .btn-visa-phone:focus,
    .btn-secondary:not(:disabled):not(.disabled):active {
        background-color: white;
        color: #333;
        outline: dotted thin !important;
    }
    .badge {
        display: flex;
        justify-content: flex-start;
        border-radius: 2px;
        font-size: 9pt;
        padding: 2px;
        font-weight: 500;
        color: #333;
        letter-spacing: 0.1pt;
        box-shadow: none !important;
    }
    .btnContainer {
        vertical-align: middle !important;
    }
    p {
        margin: 2px 0;
    }
    .btn-to-top {
        display: flex;
        justify-content: center;
        align-items: center;
        min-height: 80px;
        min-width: 150px;
        padding: 10px 15px;
        color: #333;
        border: 1px solid transparent;
        line-height: 2;
        font-size: 14px;
        background: rgba(238, 238, 238, 0.9);
        border-radius: 0;
        box-shadow: 0 1px 3px rgba(238, 238, 238, 0.12), 0 1px 2px rgba(238, 238, 238, 0.24);
        transition: color 0.2s ease, background-color 0.2s ease, transform 0.3s ease;
        font-weight: 400;
        overflow: hidden;
        bottom: 100px!important;
        right: 100px!important;
    }

    @media only screen and (max-width: 1312px) {
        .btn-visa-forsyn {
            font-size: 8pt;
        }
        .btn-visa-phone {
            font-size: 9pt;
            max-width: 90px;
            padding: 0 10px;
        }
        .btn-to-top {
            font-size: 18pt;
        }
        p {
            font-size: 9pt;
            margin: 2px 0px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/forsynlist.vue